import { Lang } from '../../../Footer';

export type ClientsMenuItem =
  | 'hc'
  | 'contacts'
  | 'promocode'
  | 'bonuses'
  | 'paylater'
  | 'agreement'
  | 'privacy';
export type BusinessMenuItem = 'b2b' | 'extranet' | 'partners';
export type PartnershipMenuItem = 'advertisers' | 'bloggers';
export type ProjectsMenuItem = 'kudablin' | 'rebuses' | 'travelMore';
export type CompanyMenuItem = 'about' | 'jobs' | 'reviews' | 'blog' | 'pomosch';
export type AdditionalMobileMenuItem = 'faq' | 'supportFeedback';

export type MenuItems = {
  clients?: ClientsMenuItem[];
  business?: BusinessMenuItem[];
  partnership?: PartnershipMenuItem[];
  projects?: ProjectsMenuItem[];
  company?: CompanyMenuItem[];
};

export default function getMenuItems(lang: Lang): MenuItems {
  let menuItems: MenuItems = {
    clients: ['hc', 'contacts', 'promocode', 'bonuses', 'paylater', 'agreement', 'privacy'],
    business: ['b2b', 'extranet', 'partners'],
    partnership: ['advertisers', 'bloggers'],
    projects: ['kudablin', 'rebuses', 'travelMore'],
    company: ['about', 'jobs', 'reviews', 'blog', 'pomosch'],
  };

  switch (lang) {
    case 'ru':
      break;
    case 'ru-ua':
    case 'ru-kz':
      menuItems = {
        clients: ['hc', 'bonuses', 'agreement', 'privacy'],
        projects: ['travelMore'],
        company: ['about', 'blog'],
      };
      break;
    case 'ru-by':
      menuItems = {
        clients: ['hc', 'bonuses', 'agreement', 'privacy'],
        projects: ['travelMore'],
        company: ['about', 'blog', 'jobs'],
      };
      break;
    case 'uk-ua':
      menuItems = {
        clients: ['hc', 'bonuses', 'privacy'],
        company: ['about', 'jobs'],
      };
      break;
    default:
      menuItems = {
        clients: ['hc', 'bonuses', 'agreement', 'privacy'],
        company: ['about'],
      };
      break;
  }

  return menuItems;
}
